import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject } from 'rxjs';

import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';


export interface Usuario {
  logeado: boolean;
  idUser: String;
  nombre: String;
  email: String;
  client_id: number;
}


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private static api: string;
  currentUserSubject: any;
  headerToken(): HttpHeaders { return new HttpHeaders().set('Authorization', `Bearer ${this.getDatosUser("token")}`); }
  headerConte(): HttpHeaders { return new HttpHeaders().set('Content-Type', 'application/json'); }

  private static tiposSe = { up: "login", rfid: "login" };

  private userObservable$ = new Subject<Usuario>();

  getUrl(): string { return AuthService.api; }
  constructor(private http: HttpClient, private router: Router) {
    AuthService.api = environment.BACKEND + "/api";
    this.comprobarLogeoObservable$();
  }

  obtener() {
    return this.http.get(`${this.getUrl()}/obtenerPersonas.php`);
  }

  logIn(email: String, password: String) {
    return this.http.get(`${this.getUrl()}/obtenerPersonas.php`);
  }


  nuevoUsuario(logeado: boolean, idUser: string, name: string, email: string, client_id: number): Usuario {
    return {
      logeado: logeado,
      idUser: idUser,
      nombre: name,
      email: email,
      client_id: client_id,
    };
  }


  iniciarSesion(parametros: any) {

    this.http.post(AuthService.api + '/loginBackOffice', parametros)
      .subscribe((resp: any) => {
        this.router.navigate(['home']);
        console.log(resp)
        this.setDatosUser(resp.user_token, (resp.user_id ?? '').toString(), resp.user_name, resp.user_email, resp.client_id.toString(), resp.user_rol.toString(), resp.user_id_login.toString());
        this.crearObservableUser$();

        this.router.navigate(['/home']);
        console.log('ya deberia haber logeado')

      });
  }


  cerrarSesion() {

    localStorage.removeItem('token')
    localStorage.removeItem('idUser')
    localStorage.removeItem('name')
    localStorage.removeItem('email')
    localStorage.removeItem('client_id')
    localStorage.removeItem('userRol')
    localStorage.removeItem('userIdLogin')
    let userObservableAUX: Usuario;
    userObservableAUX = this.nuevoUsuario(false, "", "", "", 0);
    this.userObservable$.next(userObservableAUX);

    this.router.navigate(['/account/login']);

  }

  private setDatosUser(idToken: string, id: string, name: string, email: string, client_id: string, user_rol: string, user_id: string) {

    localStorage.setItem('token', idToken);
    localStorage.setItem('idUser', id);
    localStorage.setItem('name', name);
    localStorage.setItem('email', email);
    localStorage.setItem('client_id', client_id);
    localStorage.setItem('userRol', user_rol);
    localStorage.setItem('userIdLogin', user_id);

    this.tiempoSesion();

  }

  tiempoSesion() {

    let tiempo = new Date();
    let newHora = tiempo.getHours() + 24;
    tiempo.setHours(newHora);
    localStorage.setItem('expiraRD', tiempo.getTime().toString());

  }

  getUserAbilities() {
    var roles_abilities = localStorage.getItem('roles_abilities');
    console.log('roles_abilities')
    console.log(roles_abilities)
    if (roles_abilities != null) {
      var abilitiesList = [];
      var json_roles_abilities = JSON.parse(roles_abilities);
      console.log(json_roles_abilities)
      for (var abilitie of json_roles_abilities) {
        abilitiesList.push(abilitie);
      }
      return abilitiesList;
    } else {
      return [];
    }
  }

  getDatosUser(dato: string): string {
    if (localStorage.getItem(dato)) {
      return localStorage.getItem(dato);
    } else {
      return "";
    }
  }

  crearObservableUser$() {

    let userObservableAUX: Usuario;
    userObservableAUX = this.nuevoUsuario(true, this.getDatosUser("idUser"), this.getDatosUser("name"), this.getDatosUser("email"), Number.parseInt(this.getDatosUser("client_id")));

    this.userObservable$.next(userObservableAUX);

  }

  getObservableUser$(): Observable<Usuario> {

    return this.userObservable$.asObservable();

  }

  peticionGet(urlApi: string) {
    console.log(AuthService.api)
    let token = this.getDatosUser('token').toString().trim();
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      'Access-Control-Allow-Origin': '*',
      "Access-Control-Allow-Headers": "X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method",
      "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, DELETE",
      "Allow": "GET, POST, OPTIONS, PUT, DELETE",
      "Authorization": "Bearer " + token
    });
    return this.http.get(AuthService.api + urlApi, { headers: headers });

  }

  peticionGetLocal(urlApi: string) {
    console.log(AuthService.api)
    let token = this.getDatosUser('token').toString().trim();
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      'Access-Control-Allow-Origin': '*',
      "Access-Control-Allow-Headers": "X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method",
      "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, DELETE",
      "Allow": "GET, POST, OPTIONS, PUT, DELETE",
      "Authorization": "Bearer " + token
    });
    return this.http.get("http://127.0.01:8000/api" + urlApi, { headers: headers });

  }

  // peticionDelete(urlApi: string) {

  //   const parametros = { headers: this.headerToken() };

  //   return this.http.delete(AuthService.api + urlApi, parametros);

  // }

  peticionPost(urlApi: string, body: any): any {

    let aux = new HttpHeaders();

    aux = aux.set('Authorization', "Bearer " + this.getDatosUser("token")).set('Content-Type', 'application/json');
    console.log(aux)


    const parametros = { headers: aux };



    return this.http.post(AuthService.api + urlApi, body, parametros);

  }

  peticionPostLocal(urlApi: string, body: any): any {

    let aux = new HttpHeaders();

    aux = aux.set('Authorization', "Bearer " + this.getDatosUser("token")).set('Content-Type', 'application/json');
    console.log(aux)


    const parametros = { headers: aux };



    return this.http.post("http://127.0.0.1:8000/api" + urlApi, body, parametros);
  }

  peticionPostNotificaciones(urlApi: string, body: any): any {

    let aux = new HttpHeaders();

    const token = "677|YuqDyVaE5GwaxZqqX1jJb8vG0rhhy5CcijDPFfWC";

    aux = aux.set('Authorization', `Bearer ${token}`)
             .set('Content-Type', 'application/json');
    console.log(aux)


    const parametros = { headers: aux };



    return this.http.post("https://gestion-be.marsav.cloud/api" + urlApi, body, parametros);

  }



  peticionPostBlob(urlApi: string, body: any): any {

    let aux = new HttpHeaders();

    aux = aux.set('Authorization', "Bearer " + this.getDatosUser("token")).set('Content-Type', 'application/json');
    console.log(aux)

    return this.http.post(AuthService.api + urlApi, body, { headers: aux, responseType: 'blob' });

  }
  peticionPostMultipart(urlApi: string, body: any): any {

    let aux = new HttpHeaders();

    aux = aux.set('Authorization', "Bearer " + this.getDatosUser("token"));
    aux.delete('Content-Type')
    aux.set('Content-Type', 'multipart/form-data');
    console.log(aux)


    const parametros = { headers: aux };



    return this.http.post(AuthService.api + urlApi, body, parametros);

  }

  peticionPatch(urlApi: string, body: any): any {

    let aux = new HttpHeaders();

    aux = aux.set('Authorization', "Bearer " + this.getDatosUser("token")).set('Content-Type', 'application/json');
    console.log(aux)


    const parametros = { headers: aux };



    return this.http.patch(AuthService.api + urlApi, body, parametros);

  }
  peticionDelete(urlApi: string, body: any): any {

    let aux = new HttpHeaders();

    aux = aux.set('Authorization', "Bearer " + this.getDatosUser("token")).set('Content-Type', 'application/json');
    console.log(aux)


    const parametros = { headers: aux, body: body };



    return this.http.delete(AuthService.api + urlApi, parametros);

  }

  estaLogeado(): boolean {

    let aux = localStorage.getItem('expiraRD');
    if (aux === null) {
      return false;
    }

    let expira = parseInt(localStorage.getItem('expiraRD'));
    let expiraDate = new Date();
    expiraDate.setTime(expira);

    if (expiraDate > new Date()) {
      this.tiempoSesion();
      return true;
    } else {
      return false;
    }
  }


  comprobarLogeoObservable$() {

    if (this.estaLogeado()) {
      this.crearObservableUser$();
    } else {
      let userObservableAUX: Usuario;
      userObservableAUX = this.nuevoUsuario(false, "", "", "", 0);
      this.userObservable$.next(userObservableAUX);

    }

  }

  peticionUpdateNotifications(body: any): Observable<any> {

    let aux = new HttpHeaders();
    const urlApi = "/updateNotificationPreferences";

    aux = aux.set('Authorization', "Bearer " + this.getDatosUser("token")).set('Content-Type', 'application/json');
    console.log(aux)

    const parametros = { headers: aux };
    console.log("Enviando datos al servidor:", JSON.stringify(body, null, 2));


    return this.http.patch(AuthService.api + urlApi, body, parametros);

  }

}
